var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8147925,0.190801685 L13.3100401,2.69062354 C13.56332,2.9443677 13.56332,3.35527601 13.3100401,3.60902017 L4.12669676,12.8091983 C4.00476407,12.9313545 3.83925364,13 3.66665664,13 L1.15,13 C0.791014913,13 0.5,12.7089851 0.5,12.35 L0.5,9.841555 C0.5,9.66900269 0.568610031,9.50353133 0.690710439,9.38160598 L9.89546284,0.190050984 C10.1495213,-0.0636432161 10.5611487,-0.0633070918 10.8147925,0.190801685 Z",
    id: "Edit",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.eb9a92205fc7f8ecd8a0e432b2d2b1c5.svg";
export { ForwardRef as ReactComponent };